var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"app-link-open",attrs:{"rel":"noopener noreferrer","target":"_blank","href":_vm.url}},[_vm._v(_vm._s(_vm.name ? _vm.name : _vm.url)),_c('span',{staticClass:"sr-only"},[_vm._v("(opens in a new window or tab)")])])}
var staticRenderFns = []

export { render, staticRenderFns }